import React from "react";
import MyCalendar from "../Calendar/MyCalendar";
import Header from "../Header/Header";

const Home = () => {
  return (
    <div className="home">
      <Header />
      <MyCalendar />
    </div>
  );
};

export default Home;
